<script>
  import { _ as t } from "svelte-i18n";
  import { Button } from "t2c-components";

  export let onSave;
  export let onClose;
  export let action;
  export let title;
  export let confirm;

  let error;

  const handleConfirm = () => {
    action()
      .then((res) => {
        onSave();
      })
      .catch((e) => {
        console.log(e);
        error = e;
      });
  };

  const handleReject = () => {
    onClose();
  };
</script>

<div class="modal">
  <h1>{title}</h1>
  <p>
    {@html confirm}
  </p>
  {#if error}
    <p class="error">{error}</p>
    <ul class="error">
      {#each error.graphQLErrors as gqlError}
        <li>{$t(`common.${gqlError.key}`) || ""}: {gqlError.message}</li>
      {/each}
    </ul>
  {/if}

  <div>
    <Button
      style="filled"
      text={$t("common.deleteReject")}
      on:click={handleReject}
    />
    <Button text={$t("common.deleteConfirm")} on:click={handleConfirm} />
  </div>
</div>

<style>
  .modal {
    margin: 2rem;
  }
  .modal h1 {
    font-size: 24px;
    text-transform: uppercase;
    font-family: "IBM Plex Sans";
    font-weight: 700;
    letter-spacing: 0.02rem;
    margin: 0;
  }

  .modal p {
    line-height: 1.75rem;
  }

  .error {
    color: red;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  .error li {
    margin: 0;
    padding: 0;
  }
</style>
